const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/mcp_connector.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/mcp_connector")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "AI Assistant Connector (MCP)",
      description: "Page title"
    })
  }
});